import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { hotMelons } from '@/mocks/home';

export default function HotMelons() {
  const [activeId, setActiveId] = useState(hotMelons[0].id);
  const active = hotMelons.find((item) => item.id === activeId) ?? hotMelons[0];

  const shuffle = () => {
    const others = hotMelons.filter((item) => item.id !== active.id);
    const next = others[Math.floor(Math.random() * others.length)];
    setActiveId(next.id);
  };

  return (
    <section id="hot" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="热门内容推荐"
            title="今日瓜田，先挑一个开开胃"
            desc="这些场景你大概率都遇到过。我们不光讲发生了什么，更想聊聊当时你心里在想什么。"
          />
          <button
            type="button"
            onClick={shuffle}
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-secondary-500 text-background-50 text-sm hover:bg-secondary-600 transition-colors whitespace-nowrap self-start lg:self-auto"
          >
            <i className="ri-refresh-line" />
            换一个瓜
          </button>
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <article className="lg:col-span-7 rounded-lg overflow-hidden bg-background-100 border border-background-200">
            <div className="relative w-full h-[240px] md:h-[360px]">
              <img
                src={active.image}
                alt={`${active.title} 主题插画`}
                className="w-full h-full object-cover object-top"
              />
              <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-background-50/90 text-xs text-accent-700 font-medium">
                {active.tag}
              </span>
            </div>
            <div className="p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {active.heat}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" />
                  阅读约 {active.readTime}
                </span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mt-3">{active.title}</h3>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">{active.excerpt}</p>
              <a
                href="#psych"
                className="mt-5 inline-flex items-center gap-1.5 text-sm text-primary-700 hover:text-primary-800 transition-colors"
              >
                看看这背后的心理机制
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </article>

          <div className="lg:col-span-5 flex flex-col gap-3">
            {hotMelons.map((item) => {
              const isActive = item.id === active.id;
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setActiveId(item.id)}
                  className={`text-left p-4 rounded-lg border transition-colors ${
                    isActive
                      ? 'bg-primary-50 border-primary-300'
                      : 'bg-background-100 border-background-200 hover:border-primary-200 hover:bg-background-200/60'
                  }`}
                >
                  <div className="flex items-center justify-between gap-3">
                    <span
                      className={`text-xs px-2 py-0.5 rounded-full ${
                        isActive ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-900'
                      }`}
                    >
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.readTime}</span>
                  </div>
                  <h4 className="mt-2 text-sm md:text-base font-medium text-foreground-900 leading-snug">
                    {item.title}
                  </h4>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}